export default class HDCPDetector {
  static get config() {
    return [{
      videoCapabilities: [{
        contentType: 'video/webm; codecs="vp09.00.10.08"',
        robustness: 'SW_SECURE_DECODE'
      }]
    }];
  }

  static get media_key() {
    return 'com.widevine.alpha';
  }

  static async check() {
    if (!navigator.requestMediaKeySystemAccess) {
      return Promise.reject('navigator.requestMediaKeySystemAccess is unavailable.');
    }

    try {
      const mediaKeySystemAccess = await navigator.requestMediaKeySystemAccess(this.media_key, this.config);
      const mediaKeys = await this.createMediaKeys(mediaKeySystemAccess);
      const hdcp_status = await this.checkMediaKeys(mediaKeys);
      return this.checkHDCPStatus(hdcp_status);
    } catch (result) {
      return this.markAsUnknown(result);
    }
  }

  static createMediaKeys(mediaKeySystemAccess) {
    return mediaKeySystemAccess.createMediaKeys();
  }

  static checkMediaKeys(mediaKeys) {
    if (!('getStatusForPolicy' in mediaKeys)) {
      return Promise.reject('unsupported');
    }

    return mediaKeys.getStatusForPolicy({ minHdcpVersion: '1.0' });
  }

  static checkHDCPStatus(hdcp_status) {
    if (hdcp_status !== 'usable') {
      return Promise.resolve('unsupported');
    }
    return Promise.resolve('supported');
  }

  static markAsUnknown() {
    return Promise.resolve('unknown');
  }
}
